import React, { createRef, CSSProperties, forwardRef, ReactNode } from "react";
import classNames from "classnames";
import ImageOrVideo from "../ImageOrVideo";
import { useLocSettings } from "../../hooks/SettingsHooks";
import { cmsAssetUrl } from "../../utils/CmsUtils";
import EnterViewportAnimation from "../EnterViewportAnimation";
import { Theme } from "../../config/themes";
import { Asset } from "../../types/Asset";
import "./style.scss";

const ImageBox = forwardRef<
  HTMLDivElement,
  {
    id?: string;
    backgroundImage?: string | object;
    centerImage?: boolean;
    imageAltText?: string;
    theme?: Theme;
    textShadow?: boolean;
    className?: string;
    style?: CSSProperties;
    deferLoading?: boolean;
    ariaLabel?: string;
    children?: ReactNode;
  }
>((props, ref) => {
  ref = ref || createRef();
  const {
    backgroundImage,
    centerImage,
    imageAltText,
    theme = "black",
    textShadow = false,
    id,
    className,
    style = {},
    deferLoading = false,
    ariaLabel = "",
    children,
    ...rest
  } = props;
  const settings = useLocSettings();
  const image = backgroundImage
    ? typeof backgroundImage === "object"
      ? backgroundImage
      : { path: backgroundImage, image: true }
    : {
        ...settings.default_bg_image,
        path: cmsAssetUrl(settings.default_bg_image?.path)
      };

  const classes = classNames(
    "image-box",
    "theme-" + theme,
    { "text-shadow": textShadow },
    className
  );

  return (
    <div
      ref={ref}
      key={id}
      id={id}
      {...rest}
      className={classes}
      style={style}
      aria-label={ariaLabel}
    >
      {!deferLoading && (
        <ImageOrVideo
          image={image as Asset}
          className="image-box-bkg"
          centerImage={centerImage}
          altText={imageAltText}
        />
      )}
      <div className="image-box-content-wrapper">
        <div className="image-box-content">
          <EnterViewportAnimation mode="fade-up">
            {children}
          </EnterViewportAnimation>
        </div>
      </div>
    </div>
  );
});
ImageBox.displayName = "ImageBox";

export default ImageBox;
